export const titleWhite = "Use your imagination ";
export const titlePink = "with our styles";
export const subtitle =
  "Choose from our ready-made styles, or use the prompt to transform your look in an instant.";
